import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import IconError from '../../images/icon-error.svg';
import IconErrorCard from '../../images/icon-error-card.svg';

const Error = (props) => {
    let icon = null;
    let title = '';
    let text = '';
    let isShowCallToService = false;
    let linkText1 = '';
    let linkHref1 = '';
    let linkText2 = '';
    let linkHref2 = '';
    let buttonText = '';

    switch (props.type) {
        case "noTvSubscription":
            icon = IconError;
            title = `מצטערים, אנחנו לא מזהים שיש \n לכם  שירות ${window.Config.brand_Name_HE} TV`;
            text = 'יכול להיות שנרשמתם עם פרטים אחרים? \n שווה לנסות להתחבר שוב'
            buttonText = 'חזרה לאזור האישי';
            linkText1 = 'לחצו כאן להצטרפות לשירות';
            linkHref1 = props.joinTvServiceLink;
            break;
        case "hasDebt":
            icon = IconErrorCard;
            title = 'לקוח לא מורשה לבצע את הפעולה';
            text = 'על פי רישומנו הינך נדרש לשלם את החוב'
            buttonText = 'חזרה לאזור האישי';
            linkText1 = 'לתשלום החוב';
            linkHref1 = props.debtPaymentLink;
            break;
        case "hasPaymentMethodIssue":
            icon = IconErrorCard;
            title = 'לקוח לא מורשה לבצע את הפעולה';
            text = `על פי רישומנו הינך נדרש לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE}`
            buttonText = 'חזרה לאזור האישי';
            linkText1 = 'לעדכון אמצעי תשלום';
            linkHref1 = props.updatePaymentLink;
            break;
        case "hasDebtAndHasPaymentMethodIssue":
            icon = IconErrorCard;
            title = 'לקוח לא מורשה לבצע את הפעולה';
            text = `על פי רישומנו הינך נדרש לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE} ולשלם את החוב`;
            buttonText = 'חזרה לאזור האישי';
            linkText1 = 'לתשלום חוב';
            linkHref1 = props.debtPaymentLink;
            linkText2 = 'לעדכון אמצעי תשלום';
            linkHref2 = props.updatePaymentLink;
            break;
        case "notAllowed":
            icon = IconError;
            title = 'לקוח לא מורשה לבצע את הפעולה';
            text = ''
            buttonText = 'חזרה לאזור האישי';
            break;
        case "isNotJetCustomer":
            icon = IconError;
            title = 'מצטערים, כרגע לא ניתן לבצע \n את הפעולה שביקשת';
            text = 'נציגנו ישמחו לסייע לך'
            buttonText = 'חזרה לאזור האישי';
            isShowCallToService = true;
            break;
        case "generalError":
            icon = IconError;
            title = 'אופס...\n אירעה שגיאה';
            text = 'שווה לנסות להתחבר שוב'
            buttonText = 'חזרה לאזור האישי';
            break;
        default:
            break;
    }

    return (
        <div className='premium-packages-catalog-error' data-description={props.description}>
            <Image className='icon' src={icon} alt='' />
            <h2 className='error-title'>{title}</h2>
            <p className='error-text'>{text}</p>
            {isShowCallToService &&
                <div className='service-phone'>
                    {isMobile ?
                        <>
                            <a className='phone-call' href={`tel:${window.Config.technicalSupportPhone}`} onClick={() => props.onServiceClick('Phone')}>חייגו {window.Config.technicalSupportPhone} לנציג שירות</a>
                            <a className='whatsapp' target='_blank' href={`https://api.whatsapp.com/send?phone=${window.Config.whatsAppSelfCare}`} onClick={() => props.onServiceClick('WhatsApp')}>לנציג שירות ב - WhatsApp <i class="fa fa-whatsapp whatsapp-icon"></i></a>
                        </> :
                        <>
                            <a className='whatsapp' target='_blank' href={`https://api.whatsapp.com/send?phone=${window.Config.whatsAppSelfCare}`} onClick={() => props.onServiceClick('WhatsApp')}>לנציג שירות ב - WhatsApp <i class="fa fa-whatsapp whatsapp-icon"></i></a>
                            <a className='phone-call border-none' href={null} onClick={() => props.onServiceClick('Phone')}>חייגו {window.Config.technicalSupportPhone} לנציג שירות</a>
                        </>
                    }
                </div>}
            <div className='btn-wrapper'>
                {linkText1 && linkHref1 && <a className='error-link' href={linkHref1} onClick={() => props.onClickLink()}>{linkText1}</a>}
                {linkText2 && linkHref2 && <a className='error-link' href={linkHref2} onClick={() => props.onClickLink()}>{linkText2}</a>}
                <BtnWhiteBlackBorderBigSize text={buttonText} onclick={() => props.onClickBtn()} />
            </div>
        </div>
    );
};



export default Error;
